
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

    report_12
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,

            loading: false,
            data: [],
            data_admin: [],

            page: 1,
            data_search: "",

            goods_issuance_code: "",
            goods_issuance_main_id: ""

        }
    }

    btnType = 'buy';

    async componentDidMount() {
        await this.Get();
        await this.GetAdmin();
    }

    GetAdmin = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            user_id: ""
        }
        let result = await GET(tokens, "v1/TH/user-admin/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data_admin: result.data.map(e => { return { value: e.user_id, label: e.full_name } }) });
        }
        this.setState({ loading: false });
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            goods_issuance_main_id: ""
        }
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);

            this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    }

    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            goods_issuance_main_id: id
        }
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            result.data.goods_issuance_by = result.data.goods_issuance_by ? this.state.data_admin.filter(e => e.value === result.data.goods_issuance_by).length !== 0 ? this.state.data_admin.filter(e => e.value === result.data.goods_issuance_by)[0] : "" : ""

            console.log("GetById:", result);
            report_12(result.data)
        }
        this.setState({ loading: false });
    }

    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/goods-issuance-manage/delete/" + this.state.goods_issuance_main_id, null);
        if (result && result.status) {
            success_url("/stock/list-spare-parts")
        }
        this.setState({ loading: false });
    }

    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการสต๊อก" page3="เบิกอะไหล่" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>เบิกอะไหล่</b></h3>
                            <button className="btn btn-orange" onClick={() => { window.location.href = "/stock/spare-parts/create" }}>
                                สร้างใหม่
                            </button>
                        </div>
                        <div className="w-100 card border-0 p-0">
                                <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                    <button className={`btn mx-1 mb-2 button-filter ${this.btnType === 'repair' ? 'btn-orange' : 'btn-outline-orange'}`} onClick={() => {
                                        this.setState({ page: 1 });
                                        this.btnType = 'repair';
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        เบิกเพื่อซ่อม
                                    </button>
                                    <button className={`btn mx-1 mb-2 button-filter ${this.btnType === 'buy' ? 'btn-orange' : 'btn-outline-orange'}`} onClick={() => {
                                        this.setState({ page: 1 });
                                        this.btnType = 'buy';
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        เบิกเพื่อขาย
                                    </button>
                                </div>
                                <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                    <input
                                        className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                this.setState({ page: 1 });
                                                setTimeout(() => {
                                                    this.Get();
                                                }, 10);
                                            }
                                        }}
                                        value={this.state.data_search}
                                    />

                                    <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                        this.setState({ page: 1 });
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        ค้นหา
                                    </button>
                                    <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                        this.setState({ page: 1, data_search: "" });
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        รีเซ็ต
                                    </button>
                                </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">เลขที่เอกสาร</th>
                                            <th className="text-center text-white">วันที่เอกสาร</th>
                                            <th className="text-left text-white">รหัสใบแจ้งซ่อม</th>
                                            <th className="text-left text-white">ประเภทการเบิก</th>
                                            <th className="text-left text-white">สถานะ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.goods_issuance_code ? item.goods_issuance_code : "-"}</td>
                                                <td className="text-center">{item.goods_issuance_date ? format_date(item.goods_issuance_date, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-left">{item.ref_repaire_code ? item.ref_repaire_code : "-"}</td>
                                                <td className="text-left">{item.deposite_type === 'buy' ? "เบิกเพื่อขาย" : "เบิกเพื่อซ่อม"}</td>
                                                <td className="text-left">{item.decision_status === 1 ? "เบิกแล้ว" : "ยังไม่ได้เบิก"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">

                                                        {item.decision_status === 0 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/stock/spare-parts/update?id=" + item.goods_issuance_main_id }}>
                                                                <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                            </div>
                                                        )}
                                                        {item.decision_status === 0 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { this.setState({ modal_delete: true, goods_issuance_code: item.goods_issuance_code, goods_issuance_main_id: item.goods_issuance_main_id }) }}>
                                                                <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                            </div>
                                                        )}
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { this.GetById(item.goods_issuance_main_id) }}>
                                                            <label className="pointer icon text-cyan p-2">{"\uf02f"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบใบเบิกอะไหล่</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบใบเบิกอะไหล่ “{this.state.goods_issuance_code}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
